export enum TransferDirection {
  SENDING = 'SENDING',
  RECEIVING = 'RECEIVING',
}
